import React from "react";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateLookUpTableForm from "./forms/CreateFactTableForm";
import { FORM_TYPE_ADD } from "../../../_helpers/constants";

export default function CreateFactTable() {
     return (
          <>
               <MainLeftTitle title="Create Fact Table"></MainLeftTitle>
               <CreateLookUpTableForm type={FORM_TYPE_ADD} />
          </>
     );
}
